// src/components/Navigation.tsx
import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { MessageCircle, User } from "lucide-react";
import { Sparkle } from "./icons/MystaraOutline";

export function Navigation() {
  const { user, signOut, isConfigured } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  
  const isActive = (p: string) => location.pathname.startsWith(p);
  
  const handleSignOut = async () => {
    await signOut();
    navigate("/");
  };
  
  return (
    <>
      <nav className="holo-nav">
        <div className="holo-nav-inner">
          <Link to="/" className="holo-brand">
            <div className="holo-brand-icon">
              <Sparkle className="w-5 h-5" />
            </div>
            <span className="holo-brand-text">Mystara</span>
          </Link>
          
          <div className="holo-actions">
            {user ? (
              <>
                <Link
                  to="/chat"
                  className={isActive("/chat") ? "holo-tab is-active" : "holo-tab"}
                >
                  <MessageCircle className="w-4 h-4" />
                  <span className="hidden sm:inline">Chat</span>
                </Link>
                <Link
                  to="/dashboard"
                  className={isActive("/dashboard") ? "holo-tab is-active" : "holo-tab"}
                >
                  <User className="w-4 h-4" />
                  <span className="hidden sm:inline">Dashboard</span>
                </Link>
                <button onClick={handleSignOut} disabled={!isConfigured} className="holo-chip">
                  Sign Out
                </button>
              </>
            ) : (
              <>
                <Link to="/auth/sign-in" className="holo-tab">Sign In</Link>
                <Link to="/auth/sign-up" className="holo-chip">Get Started</Link>
              </>
            )}
          </div>
        </div>
      </nav>
      <div className="holo-nav-spacer" />
    </>
  );
}
